export default {
  name: 'SkeletonLoader',
  props: {
    item: {
      type: String,
      required: false,
    },
    communityTopics: {
      type: Number,
      default: 0,
    },
    header: {
      type: Boolean,
      default: false,
    },
    image: {
      type: Boolean,
      default: false,
    },
    imageHeight: {
      type: String,
      required: false,
    },
    content: {
      type: Boolean,
      default: false,
    },
    contentCenter: {
      type: Boolean,
      default: false,
    },
    contentBody: {
      type: Number,
      default: 0,
    },
    contentBodyFlex: {
      type: Boolean,
      default: false,
    },
    footer: {
      type: Boolean,
      default: false,
    },
    footerLinks: {
      type: Number,
      default: 1,
    },
    footerIcons: {
      type: Number,
      default: 0,
    },
    magazine: {
      type: Boolean,
      default: true
    },
    listItems: {
      type: Number,
      default: 1,
    },
    checkboxes: {
      type: Number,
      default: 1,
    },
    toggleOptions: {
      type: Number,
      default: 1,
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    grid: {
      type: Boolean,
      default: false
    },
    gridRows: {
      type: Number,
      default: 1,
    },
    gridColumns: {
      type: Number,
      default: 4,
    },
  },
};
